import script from "./SquareIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./SquareIcon.vue?vue&type=script&setup=true&lang=js"

import "./SquareIcon.vue?vue&type=style&index=0&id=00ce1dc3&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00ce1dc3"]])

export default __exports__